export var defaultProps = {
    className: '',
    style: undefined,
    close: false,
    color: '',
    type: 'default',
    shape: 'rounded',
    isFill: false,
    visible: true,
    icon: undefined,
    onClose: function (e) { },
};
export var checkableTagDefaultProps = {
    className: '',
    style: undefined,
    checked: false,
    onChange: function () { },
};
